import { css } from '@emotion/css';
import { useEffect, useState } from 'react';
interface Props {
    data: { id: string; result: string[] }[];
    onClose: () => void;
}

export default function HisPhienRongHo(props: Props) {
    const { data, onClose } = props;
    const [statsTotal, setStatsTotal] = useState<{ rong: number; ho: number; hoa: number }>({ rong: 0, ho: 0, hoa: 0 });

    useEffect(() => {
        if (data.length > 0) {
            const statsCount = { rong: 0, ho: 0, hoa: 0 };
            data.forEach((item) => {
                const label = calcPlace(item.result);
                if (label === 'HO') {
                    statsCount.ho += 1;
                } else if (label === 'HOA') {
                    statsCount.hoa += 1;
                } else if (label === 'RONG') {
                    statsCount.rong += 1;
                }
            });
            setStatsTotal(statsCount);
        }
    }, [data]);

    const calcPlace = (result: string[]) => {
        const resultNum = result.map((item) => Number(item.split('-')[0]));
        let label: 'HOA' | 'RONG' | 'HO' = 'HOA';
        if (resultNum[0] < resultNum[1]) {
            label = 'HO';
        } else if (resultNum[0] > resultNum[1]) {
            label = 'RONG';
        }
        return label;
    };

    const generateLabel = (result: string[]) => {
        const resultNum = result.map((item) => Number(item.split('-')[0]));
        let label = 'HOÀ',
            cls = 'hoa';
        if (resultNum[0] < resultNum[1]) {
            label = 'HỔ';
            cls = 'xiu';
        } else if (resultNum[0] > resultNum[1]) {
            label = 'RỒNG';
            cls = 'tai';
        }
        return <p className={`result ${cls}`}>{label}</p>;
    };

    return (
        <div className={styles.hisPhienWrap}>
            <div className="title">LỊCH SỬ PHIÊN</div>
            <div className="close" onClick={onClose}>
                <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
            </div>
            <div className="stats-total">
                <p>
                    RỔNG: <span>{statsTotal.rong}</span>
                </p>
                <p>
                    HỔ: <span>{statsTotal.ho}</span>
                </p>
                <p>
                    HOÀ: <span>{statsTotal.hoa}</span>
                </p>
            </div>
            <div className="table-issue">
                {data.slice(-50).map((issue) => (
                    <div className="issue-item" key={issue.id}>
                        <p className="issue-text">#{issue.id && issue.id}</p>
                        {generateLabel(issue.result)}
                    </div>
                ))}
            </div>
        </div>
    );
}

const styles = {
    hisPhienWrap: css`
        padding: 20px 10px 10px;
        background-color: #241746;
        position: relative;
        border: 1px solid #b4977e;
        border-radius: 10px;
        min-width: 650px;
        min-height: 500px;
        margin: 0 auto;
        .title {
            font-family: 'Montserrat', sans-serif;
            font-size: 20px;
            color: rgb(246, 142, 86);
            font-weight: bold;
            padding-bottom: 20px;
        }
        .close {
            position: absolute;
            top: 10px;
            right: 10px;
            width: 30px;
            cursor: pointer;
            img {
                width: 100%;
            }
        }
        .stats-total {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 8px;
            color: #fff;
            p {
                flex: 0 0 25%;
                text-align: center;
                color: #fff;
                span {
                    color: #fff;
                    font-weight: 700;
                }
                &:first-child {
                    color: var(--ion-color-success);
                }
                &:nth-child(2) {
                    color: var(--ion-color-secondary);
                }
            }
        }
        .table-issue {
            display: flex;
            flex-wrap: wrap;
            gap: 4px 0;
            p {
                color: #fff;
                font-size: 14px;
            }
            .issue-item {
                flex: 0 0 20%;
                border: 1px solid #6c6b6b;

                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .result {
                padding: 4px 0;
                font-weight: 600;
                &.tai {
                    color: var(--ion-color-success);
                }
                &.xiu {
                    color: var(--ion-color-secondary);
                }
            }
            .issue-text {
                background: var(--ion-color-line);
                width: 100%;
                text-align: center;
            }
        }
    `,
};
